
import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { iPeriodCard, iPointsCard } from '@/interface/purchase';
@Component
export default class extends Vue {
  @Prop() editRecharge!: iPointsCard;
  @Prop() editRechargeTwo!: iPointsCard;
  @Prop() dialogVisible!: Boolean;
  is_corner_label: boolean = true;
  disabled: boolean = true;
  rules = {
    amount: [{ required: true, message: '请输入云币数量', trigger: 'blur' }],
    google_product_id: [{ required: true, message: '请输入Google产品ID', trigger: 'blur', validator: this.getGoogleProductId }],
    price: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
    original_price: [{ required: true, message: '请输入原价说明', trigger: 'blur' }],
    desc1: [{ required: true, message: '请输入说明', trigger: 'blur' }], // 12
    desc2: [{ required: true, message: '请输入说明', trigger: 'blur' }],
    pay_desc: [{ required: true, message: '请输入支付说明', trigger: 'blur', validator: this.getPayDesc }], // 17
    pay_desc_first: [{ required: true, message: '请输入支付说明', trigger: 'blur', validator: this.getPayDescFirst }], // 17
  };
  getGoogleProductId(rule: any, value: any, callback: any) {
    console.log(value, 'getPayDescFirst');
    if (!this.editRecharge.google_product_id) {
      return callback(new Error('请输入Google产品ID'));
    }
    return callback();
  }
  getPayDescFirst(rule: any, value: any, callback: any) {
    console.log(value, 'getPayDescFirst');
    if (!this.editRecharge.pay_desc) {
      return callback(new Error('请输入支付说明'));
    }
    return callback();
  }
  getPayDesc(rule: any, value: any, callback: any) {
    console.log(value, 'getPayDesc');

    if (!this.editRechargeTwo.pay_desc) {
      return callback(new Error('请输入支付说明'));
    }
    return callback();
  }
  @Watch('dialogVisible', { deep: true, immediate: true })
  corner_label() {
    // if (this.dialogVisible) {
    //   if (this.editRecharge.corner_label.length > 0) {
    //     this.is_corner_label = true;
    //   } else {
    //     this.is_corner_label = false;
    //   }
    // }
  }
  @Watch('editRecharge', { deep: true, immediate: true })
  is_default() {
    // if (this.editRecharge.is_first_pay) {
    //   this.editRecharge.is_default = false;
    //   this.disabled = true;
    // } else {
    //   this.disabled = false;
    // }
  }
  @Emit('handleClose')
  handleClose(formName: any, formNameTwo: any) {
    (this.$refs[formName] as Form).resetFields();
    (this.$refs[formNameTwo] as Form).resetFields();
  }
  // @Emit('editSure')
  editSure(formName: any, formNameTwo: any) {
    // if (this.editRecharge.is_first_pay || !this.is_corner_label) {
    //   this.editRecharge.corner_label = '';
    // }
    // return this.editRecharge;
    (this.$refs[formName] as Form).validate((valid: boolean) => {
      if (valid) {
        (this.$refs[formNameTwo] as Form).validate((valid: boolean) => {
          if (valid) {
            // this.editRechargeTwo.google_product_id = this.editRecharge.google_product_id;
            this.$emit('editSure', this.editRecharge, this.editRechargeTwo);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  change(e: any) {
    this.$forceUpdate();
  }
}
